/**
 * Copyright (c) Miihe, Inc. and its affiliates.
 * Date:2021/1/28
 * Power By ZhangHebo
 */
import Vue from 'vue';
let vm = new Vue();
import axios from 'axios'
import qs from 'qs';

import Config from './config'
import Utils from './utils'
import User from './user'
import Router from '../router'
import Http from './http'

// export default {
const api = {
	getAddtion:function (slug,id,success){
		Http.post({
			url: 'addtion/show',
			data: {data_id:id,slug: slug},
			success(res) {
				if(success){
					success(res);
				}
			}
		});
	}
}

export default api;
